// api/campaign.js
import request from './request'

export const campaignApi = {
    // 获取广告系列列表
    getList(params) {
        return request({
            url: '/campaign/list',
            method: 'get',
            withCredentials: false,
            params: {
                advertiserId: params.advertiserId,
                page: params.page || 1,
                pageSize: params.pageSize || 20,
                campaignName: params.campaignName || '',
                objectiveType: params.objectiveType || '',
                startDate: params.startDate || '',
                endDate: params.endDate || '',
                fields: params.fields ? params.fields.join(',') : ''  // fields 转为逗号分隔字符串
            }
        })
    },

    create(data) {
        return request({
            url: '/campaign/create',
            method: 'post',
            withCredentials: false,
            data
        })
    },

    update(data) {
        return request({
            url: '/campaign/update',
            method: 'post',
            withCredentials: false,
            data: {
                advertiserId: data.advertiser_id,
                campaignId: data.campaign_id,
                campaignName: data.campaign_name,
                budget: data.budget
            }
        })
    },

    updateStatus(data) {
        return request({
            url: '/campaign/status/update',
            method: 'post',
            withCredentials: false,
            data: {
                advertiser_id: '7598883753192357896',
                campaign_ids: data.campaign_ids,
                operation_status: data.operation_status
            }
        })
    }
}